import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../@core/auth/auth.service';
import { environment } from '../../../../environments/environment';
import { PoolTypeDTO } from '../../modules/pick-plan/models/pool-type-dto';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class PoolService {
  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService,
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }


  public getPoolTypes(includeInactive: boolean = false) {

    let queryParameters = new HttpParams();

    if (includeInactive !== undefined && includeInactive !== null) {
      queryParameters = queryParameters.set('includeInactive', <any>includeInactive);
    }

    return this.httpClient.get<PoolTypeDTO[]>(`${this.basePath}/api/poolTypes`,
      {
        // params: queryParameters,
      }
    );
  }

  public getPoolType(poolTypeId: number): Observable<PoolTypeDTO> {
    return this.httpClient.get<PoolTypeDTO>(`${this.basePath}/api/poolTypes/${poolTypeId}`);
  }

  public postPoolTypeDTO(poolTypeDTO: PoolTypeDTO): Observable<PoolTypeDTO> {
    return this.httpClient.post<PoolTypeDTO>(`${this.basePath}/api/poolTypes`, poolTypeDTO);
  }

  public putPoolTypeDTO(poolTypeDTO: PoolTypeDTO): Observable<PoolTypeDTO> {
    return this.httpClient.put<PoolTypeDTO>(`${this.basePath}/api/poolTypes/${poolTypeDTO.id}`, poolTypeDTO);
  }

  public deletePoolTypeDTO(id: number): Observable<any> {
    return this.httpClient.delete(`${this.basePath}/api/poolTypes/${id}`);
  }

}
